/**
 * stores/index.js
 *
 * All stores are listed here.  Whenever a new store is added. Add it here and import it from here.
 *
 * Example import usage:
 * import { UserStore } from 'stores';
 */
import NavStore from './NavStore';

export { NavStore };



/** WEBPACK FOOTER **
 ** ./app/scripts/stores/index.js
 **/